/**
 * The notification bell in the header of BOTH portals (admin/components/layout/
 * Header.jsx, partner/components/layout/PartnerHeader.jsx).
 *
 * Hidden by default: the bell is a placeholder — its count is hardcoded and it
 * opens nothing — so showing it promised notifications that do not exist. Set
 * REACT_APP_SHOW_HEADER_NOTIFICATIONS=true to bring it back once it is wired to
 * a real feed. One flag so the two portals cannot drift.
 */
export const SHOW_HEADER_NOTIFICATIONS = process.env.REACT_APP_SHOW_HEADER_NOTIFICATIONS === 'true';
